import React from 'react';
import useStyle from './mobileTabLineBox.style';
import { classNames } from '../../../../helpers/style/classNames';

type TextMobileTab = {
  text: string;
  style?:
    | 'bottomRegular'
    | 'bottomBold'
    | 'bold'
    | 'red'
    | 'blue'
    | 'bottomQuiz';
};

export interface MobileTabLineBoxProps {
  texts: TextMobileTab[];
  variant?: 'default' | 'red' | 'green' | 'grey' | 'orange';
  title?: string;
}

export const MobileTabLineBox = ({
  texts,
  variant = 'default',
  title
}: MobileTabLineBoxProps) => {
  const classes = useStyle();

  return (
    <>
      {title && <span className={classes.title}>{title}</span>}
      <div
        className={classNames(
          [classes.root],
          [
            { condition: variant === 'green', classe: classes.green },
            { condition: variant === 'red', classe: classes.red },
            { condition: variant === 'grey', classe: classes.grey },
            { condition: variant === 'orange', classe: classes.orange }
          ]
        )}
      >
        {texts.map((content, index) => (
          <span
            key={index}
            className={classNames(
              [],
              [
                {
                  condition: content.style === 'bottomRegular',
                  classe: classes.bottomRegular
                },
                {
                  condition: content.style === 'bottomBold',
                  classe: classes.bottomBold
                },
                {
                  condition: content.style === 'bottomQuiz',
                  classe: classes.bottomQuiz
                },
                {
                  condition: content.style === 'red',
                  classe: classes.regularRed
                },
                {
                  condition: content.style === 'blue',
                  classe: classes.regularBlue
                },
                { condition: content.style === 'bold', classe: classes.bold }
              ]
            )}
          >
            {content.text}
          </span>
        ))}
      </div>
    </>
  );
};
